/**
 * @module
 * 
 * @import {UserData} from "../model/user-data.js" 
 */

import {createGlobalContext, globalValue} from '@acng/frontend-relativity';
import {CTX_PROVIDE} from '@acng/frontend-relativity/minify';
import {authUser as authUserData} from 'acng/core/service/env.js';
import {guestFeature, userFeature} from '../config/feature.js';

export let authUser = authUserData;

export const ctxAuthUser = createGlobalContext(authUser);

/**
 * @param {UserData | null} user
 */
export const provideAuthUser = (user) => {
  authUser = user;
  userFeature.hidden = !authUser;
  guestFeature.hidden = !!authUser;
  ctxAuthUser[CTX_PROVIDE](null, authUser);
};

export const getAuthUser = () => globalValue(ctxAuthUser);

userFeature.hidden = !authUser;
guestFeature.hidden = !!authUser;
